import { PropsWithChildren } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from 'atoms/layout/flex';
import { LabelL } from 'atoms/typography';
import { fantasy } from 'lib/glossary';

import { ScoreGaugeTargetBar } from './ScoreGaugeTargeBar';

const Root = styled(Vertical).attrs({ gap: 1.5 })`
  border-radius: var(--double-unit);
  padding: var(--double-unit);
  background-color: var(--c-nd-50);
  backdrop-filter: blur(32px);
`;

type TProps = {
  name: any;
  currentScore: number;
  sections: { score: number | null }[];
  cursorPosition: string;
};

export const ScoreGaugeTarget = ({
  name,
  currentScore,
  sections,
  cursorPosition,
  children,
}: PropsWithChildren<TProps>) => {
  return (
    <Root>
      <SBHorizontal>
        {name}
        <LabelL bold>
          <FormattedMessage
            {...fantasy.pointsWithoutFormat}
            values={{
              score: (
                <FormattedNumber
                  value={currentScore}
                  maximumFractionDigits={2}
                />
              ),
            }}
          />
        </LabelL>
      </SBHorizontal>
      <ScoreGaugeTargetBar
        currentScore={currentScore}
        sections={sections}
        cursorPosition={cursorPosition}
      />
      {children}
    </Root>
  );
};
